export default __webpack_public_path__ + "static/media/gem_yellow.a14e259c.png";